import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import ShopLayout from "../Layout";
import CatalogueProductList from "../../GlobalProduct/index";
import { useSelector } from "react-redux";
import { Button } from "antd"; 
import { useNavigate } from "react-router";
import { UploadOutlined } from "@ant-design/icons";
import BreadCrumb from "../../Layouts/Breadcrumb";
 
const ShopProductCatelogueList = (): ReactElement => {
  const { shopInfo } = useSelector((state) => (state as any)?.authReducer);
  const navigate = useNavigate();

  return (
    <React.Fragment>
   
        <div className="content-body_ rounded-2xl">
          <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-0 mb-6">
            <CatalogueProductList inShop={true} getShopId={shopInfo.id} />
          </div>
        </div>
    </React.Fragment> 
  );
};

ShopProductCatelogueList.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default ShopProductCatelogueList;
